import TaskDescription from "./TaskDescription";
import TaskAttachments from "./TaskAttachments";
import TaskComments from "./TaskComments";
import TaskMeta from "./TaskMeta";


export default function TaskCard({
  task,
  onUpdate,
  onDelete,
  onImageClick,
  onDeleteAttachment,
  onAddComment,
  onDeleteComment,

  editingTaskId,
  editDescription,
  setEditDescription,
  saveDescription,
  setEditingTaskId,

  editingAssignedId,
  assignedValue,
  setAssignedValue,
  startEditAssigned,
  saveAssignedTo,

  commentInputs,
  setCommentInputs,
  submittingComment,
}) {


return (

<div
  className="
    bg-[#1a1d24]
    border
    border-slate-800
    rounded-2xl
    p-5
    shadow-lg
  "
>

<div className="flex justify-between gap-4">


<div className="flex-1">


<h2 className="text-xl font-semibold">
  {task.title}
</h2>


<TaskDescription
  task={task}
  editingTaskId={editingTaskId}
  editDescription={editDescription}
  setEditDescription={setEditDescription}
  saveDescription={saveDescription}
  setEditingTaskId={setEditingTaskId}
/>


<TaskAttachments
  task={task}
  onImageClick={onImageClick}
  onDelete={onDeleteAttachment}
/>


<TaskComments
  task={task}
  commentInputs={commentInputs}
  setCommentInputs={setCommentInputs}
  onAddComment={onAddComment}
  onDeleteComment={onDeleteComment}
  submittingComment={submittingComment}
/>


<TaskMeta
  task={task}
  onUpdate={onUpdate}
  editingAssignedId={editingAssignedId}
  assignedValue={assignedValue}
  setAssignedValue={setAssignedValue}
  startEditAssigned={startEditAssigned}
  saveAssignedTo={saveAssignedTo}
/>


</div>


<div className="flex flex-col items-end">


<button
 onClick={() => onDelete(task.id)}
 className="
 text-slate-500
 hover:text-red-400
 transition
 text-lg
 "
>
✕
</button>


<div className="text-xs text-slate-500 mt-auto">

Created by

<br />

<span className="text-slate-300">
 {task.created_by || "Unknown"}
</span>

</div>


</div>


</div>


</div>

)

}